import { defineMessages } from 'react-intl'

export default defineMessages({
  general: {
    id: 'containers.UserSettingsPage.general',
    defaultMessage: 'General',
  },
  security: {
    id: 'containers.UserSettingsPage.security',
    defaultMessage: 'Security',
  },
  notifications: {
    id: 'containers.UserSettingsPage.notifications',
    defaultMessage: 'Notifications',
  },
  features: {
    id: 'containers.UserSettingsPage.features',
    defaultMessage: 'Feature Preview',
  },
  selectTab: {
    id: 'containers.UserSettingsPage.selectTab',
    defaultMessage: 'Select a tab',
  },
})
